import { VariantService } from 'src/app/angularJS/services/variant/variant.service';
import { UserMessagesService } from 'src/app/angularJS/services/user-messages.service';
import { PermissionHelperService } from 'src/app/angularJS/services/permissionHelpers.service';
import { BreadcrumbService } from 'src/app/angularJS/services/breadcrumbs/breadcrumb.service';

/**
 * A Controller used to show a list of variants on a catalogue product
 */
export class VariantListController {
  public static $inject = [
    '$rootScope',
    '$state',
    '$stateParams',
    'product',
    'variantService',
    'PrimaryAction',
    'UserMessages',
    'catalogue',
    'permissionHelpers',
    'breadcrumbService'
  ];

  public permissions: InterACT.Interfaces.IProductVariantPermissions;

  constructor(
    private $rootScope,
    private $state: ng.ui.IStateService,
    private $stateParams,
    private product: InterACT.Interfaces.Catalogues.Product,
    private variantService: VariantService,
    private primaryAction,
    private UserMessages: UserMessagesService,
    private catalogue: InterACT.Interfaces.Catalogues.Catalogue,
    private permissionHelpers: PermissionHelperService,
    private breadcrumbService: BreadcrumbService
  ) {
    this.activate();
  }

  /**
   * Fetches the list of variants for a the catalogue product
   * @param page the page to get the variants for
   * @param perPage the number of variants per page
   * @returns a promise from the variantService
   */
  public fetchCollection = (page: number, perPage: number) => {
    this.$rootScope.showSpinner = true;
    const options = {
      catalogueVersion: this.$stateParams.catalogueVersion
    };

    return this.variantService.getList(this.catalogue.id, this.product.id, page, perPage, options).then(() => {
      this.$rootScope.showSpinner = false;
    });
  }

  /**
   * Deletes a variant from the catalogue product
   * @param variant the variant to delete
   * @returns a promise from the UserMessages dialog
   */
  public deleteVariant = (variant: InterACT.Interfaces.Catalogues.Variant) => {
    return this.UserMessages.buildConfirmDialog(
      'CONFIRM_DIALOG.VARIANT.DELETE_THIS',
      'CONFIRM_DIALOG.VARIANT.DELETE',
      { variant: variant.name },
      'CONFIRM_DIALOG.VARIANT.DELETE_CONFIRM'
    ).then(() => {
      this.variantService.remove(this.catalogue.id, this.product.id, variant.id).then(() => {
        this.UserMessages.showToast('TOAST_MESSAGE.VARIANT.DELETED');
      });
    });
  }

  /**
   * Navigates the user to the variants create screen
   */
  public goToCreate = () => {
    this.$state.go('variantsCreate', {
      catalogue: this.catalogue,
      product: this.product
    });
  }

  /**
   * Initialises the controller
   */
  private activate() {
    this.$rootScope.showSpinner = false;

    this.breadcrumbService.setBreadcrumbs([
      {
        name: 'CATALOGUES',
        sref: 'catalogues.list'
      }, {
        name: `${this.catalogue.description} (version ${this.catalogue.version})`,
        sref: 'catalogue.dashboard',
        params: {
          catalogueId: this.catalogue.id,
          catalogueVersion: this.catalogue.version
        }
      }, {
        name: 'PRODUCTS',
        sref: 'catalogue.product-list',
        params: {
          catalogueId: this.catalogue.id,
          catalogueVersion: this.catalogue.version
        }
      }, {
        name: this.product.name,
        sref: 'variant-list'
      }
    ]);

    this.permissions = this.permissionHelpers.getPermissionsForProductsVariants(this.catalogue);
    if (this.permissions.canCreate) {
      this.primaryAction.setActions([{
        name: 'Add',
        icon: 'add',
        action: this.goToCreate
      }]);
    }
    
    this.fetchCollection(1, this.variantService.perPageCount);   
  }
}